export const zIndexPayAsGo = 2000;
export const zIndexTip = zIndexPayAsGo + 1;
